import NotFound from 'components/pages/NotFound'

const PageNotFound = () => {
	return <NotFound />
}

export default PageNotFound
